import type {
  SetAlternateStepAction,
  SetCustomerDataAction,
  SetCustomFlowTypeAction,
  SetFirstStepAction,
  SetPrevStepAction,
  SetStepAction,
  SetVerificationOnMobileAction,
  SetViewTypeAction,
  SetSubmitErrorContextAction,
  SetWorkflowAction,
  ToggleInfoModalAction,
} from './types';

import { AppStateActionType } from './constants';

export function setStepAction(value: SetStepAction['value']): SetStepAction {
  return {
    type: AppStateActionType.SET_STEP,
    value,
  };
}

export function setAlternateStepAction(value: SetAlternateStepAction['value']): SetAlternateStepAction {
  return {
    type: AppStateActionType.SET_ALTERNATE_STEP,
    value,
  };
}

export function setPrevStepAction(): SetPrevStepAction {
  return {
    type: AppStateActionType.SET_PREV_STEP,
  };
}

export function setFirstStepAction(): SetFirstStepAction {
  return {
    type: AppStateActionType.SET_FIRST_STEP,
  };
}

export function setWorkflowAction(value: SetWorkflowAction['value']): SetWorkflowAction {
  return {
    type: AppStateActionType.SET_WORKFLOW,
    value,
  };
}

export function toggleInfoModalAction(value: ToggleInfoModalAction['value']): ToggleInfoModalAction {
  return {
    type: AppStateActionType.TOGGLE_INFO_MODAL,
    value,
  };
}

export function setCustomerDataAction(value: SetCustomerDataAction['value']): SetCustomerDataAction {
  return {
    type: AppStateActionType.SET_CUSTOMER_DATA,
    value,
  };
}

export function setViewTypeAction(value: SetViewTypeAction['value']): SetViewTypeAction {
  return {
    type: AppStateActionType.SET_VIEW_TYPE,
    value,
  };
}

export function setVerificationOnMobileAction(
  value: SetVerificationOnMobileAction['value'],
): SetVerificationOnMobileAction {
  return {
    type: AppStateActionType.SET_VERIFICATION_ON_MOBILE,
    value,
  };
}

export function setCustomFlowTypeAction(value: SetCustomFlowTypeAction['value']): SetCustomFlowTypeAction {
  return {
    type: AppStateActionType.SET_CUSTOM_FLOW_TYPE,
    value,
  };
}

export function setSubmitErrorContextAction(
  value: SetSubmitErrorContextAction['value'],
): SetSubmitErrorContextAction {
  return {
    type: AppStateActionType.SET_SUBMIT_ERROR_CONTEXT,
    value,
  };
}
